import { SVGProps } from 'react';
const Whiteboard = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={20}
    viewBox="0 0 24 20"
    fill="none"
    {...props}
  >
    <path
      d="M2.4 8.39999C2.4 7.44529 2.7793 6.52959 3.4544 5.85449C4.1295 5.17929 5.0452 4.79999 6 4.79999C6.9548 4.79999 7.8705 5.17929 8.5456 5.85449C9.2207 6.52959 9.6 7.44529 9.6 8.39999C9.6 9.35479 9.2207 10.2705 8.5456 10.9456C7.8705 11.6208 6.9548 12 6 12C5.0452 12 4.1295 11.6208 3.4544 10.9456C2.7793 10.2705 2.4 9.35479 2.4 8.39999ZM0 18.1988C0 15.4388 2.2388 13.2 4.9988 13.2H6.9975C9.7613 13.2 12 15.4388 12 18.1988C12 18.75 11.5538 19.2 10.9987 19.2H1.0013C0.4463 19.2 0 18.7538 0 18.1988ZM15.6 10.8H18C18.6638 10.8 19.2 11.3363 19.2 12V13.2H14.4V12C14.4 11.3363 14.9363 10.8 15.6 10.8Z"
      fill="#267AC0"
    />
    <path
      opacity="0.4"
      d="M8.4 0C7.0763 0 6 1.0763 6 2.4V3.6C6.8738 3.6 7.695 3.8325 8.4 4.2413V2.4H21.6V13.2H10.665C11.505 13.8188 12.1875 14.6438 12.63 15.6H21.6C22.9238 15.6 24 14.5238 24 13.2V2.4C24 1.0763 22.9238 0 21.6 0H8.4Z"
      fill="#267AC0"
    />
  </svg>
);

export default Whiteboard;
